import React, { useEffect, useState } from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Typography,
} from '@mui/material';
import { IoIosHome } from 'react-icons/io';
import { MdStorage } from 'react-icons/md';
import { RiGroupLine } from 'react-icons/ri';
import { IoHelpSharp } from 'react-icons/io5';
import { includes, some } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaBox, FaCheckCircle, FaTruck } from 'react-icons/fa';

const Footer = ({ value, setValue }) => {
  const navigate = useNavigate();
  const permissions =
    localStorage?.getItem('permissions') &&
    JSON?.parse(localStorage?.getItem('permissions'));

  const requiredPermissions = [
    'ALLOTED ITEM',
    'DELIVERED ITEM',
    'PICKED-UP ITEM',
  ];

  const hasExtraPermissions = permissions?.some(
    (permission) => !requiredPermissions?.includes(permission)
  );

  const showFooterIcon = hasExtraPermissions
    ? false
    : requiredPermissions.some((item) => permissions?.includes(item));

  // useEffect(() => {
  //   if (location?.pathname === '/inward-item') {
  //     setValue(0);
  //   } else if (location?.pathname === '/delivered-item') {
  //     setValue(1);
  //   } else if ('/station-delivery') {
  //     setValue(2);
  //   }
  // });

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        zIndex: 10, // Ensure it's on top of other content
      }}
    >
      <BottomNavigation
        sx={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -10px 20px rgba(150, 150, 150, 0.5)', // Add shadow directly here
        }}
      >
        {showFooterIcon && (
          <>
            {includes(permissions, 'ALLOTED ITEM') && (
              <BottomNavigationAction
                icon={
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '4px 4px',
                      borderRadius: '8px',
                      bgcolor: value === 0 ? '#E3F2FD' : 'transparent',
                      transition: 'background-color 0.3s ease',
                      '&:hover': {
                        bgcolor: '#BBDEFB',
                      },
                    }}
                  >
                    <FaBox size={20} />
                    <Typography
                      variant='caption'
                      sx={{
                        marginTop: '4px',
                        color: '#000',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      ALLOTED ITEM
                    </Typography>
                  </Box>
                }
                onClick={() => {
                  navigate('/userAccess?tab=inward');
                  setValue(0);
                }}
                selected={value === 0}
                sx={{
                  color: value === 0 && 'blue',
                }}
              />
            )}
            {includes(permissions, 'DELIVERED ITEM') && (
              <BottomNavigationAction
                icon={
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '4px 4px',
                      borderRadius: '8px',
                      bgcolor: value === 1 ? '#E3F2FD' : 'transparent',
                      transition: 'background-color 0.3s ease',
                      '&:hover': {
                        bgcolor: '#BBDEFB',
                      },
                    }}
                  >
                    <FaTruck size={20} />
                    <Typography
                      variant='caption'
                      sx={{
                        marginTop: '4px',
                        color: '#000',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      INWARD DELIVERY
                    </Typography>
                  </Box>
                }
                onClick={() => {
                  // navigate('/delivered-item');
                  navigate('/userAccess?tab=delivered');
                  setValue(1);
                }}
                selected={value === 1}
                sx={{
                  color: value === 1 && 'blue',
                }}
              />
            )}
            {includes(permissions, 'PICKED-UP ITEM') && (
              <BottomNavigationAction
                icon={
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '4px 4px',
                      borderRadius: '8px',
                      bgcolor: value === 2 ? '#E3F2FD' : 'transparent',
                      transition: 'background-color 0.3s ease',
                      '&:hover': {
                        bgcolor: '#BBDEFB',
                      },
                    }}
                  >
                    <FaCheckCircle size={24} />
                    <Typography
                      variant='caption'
                      sx={{
                        marginTop: '4px',
                        color: value === 2 ? '#1976D2' : '#000',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      OUTWARD PICK-UP
                    </Typography>
                  </Box>
                }
                onClick={() => {
                  // navigate('/station-delivery');
                  navigate('/userAccess?tab=pickup');
                  setValue(2);
                }}
                selected={value === 2}
                sx={{
                  color: value === 2 && 'blue',
                }}
              />
            )}
          </>
        )}
      </BottomNavigation>
    </div>

    // <BottomNavigation sx={{ position: 'fixed', bottom: 0, width: '100%' }}>
    //   {showFooterIcon && (
    //     <>
    //       {includes(permissions, 'ALLOTED ITEM') && (
    //         <BottomNavigationAction
    //           label='Home'
    //           icon={<FaBox />}
    //           onClick={() => navigate('/inward-item')}
    //         />
    //       )}
    //       {includes(permissions, 'DELIVERED ITEM') && (
    //         <BottomNavigationAction
    //           label='Assets'
    //           icon={<FaTruck />}
    //           onClick={() => navigate('/delivered-item')}
    //         />
    //       )}
    //       {includes(permissions, 'PICKED-UP ITEM') && (
    //         <BottomNavigationAction
    //           label='Help Center'
    //           icon={<FaCheckCircle />}
    //           onClick={() => navigate('/station-delivery')}
    //         />
    //       )}
    //     </>
    //   )}
    // </BottomNavigation>
  );
};

export default Footer;
